export const BASE_URL = import.meta.env.VITE_BACKEND_DOMAIN || "http://localhost:8000"